export default __webpack_public_path__ + "static/media/number8.fdf20dec.svg";